export enum StorageKeys {
  SelfCareToken = 'authSelfcareToken',
  VisitorId = 'visitorId',
  AccountId = 'accountId',
  LineCheckAddress = 'lineCheckData',
  LineCheckAddressPos = 'lineCheckDataPos',
  Translations = 'translations',
  PrismicTranslations = 'prismicTranslations',
  LocalTranslations = 'localTranslations',
  FeatureFlag = 'featureFlags',
  Pos = 'authPosToken',
  CurrentLanguage = 'currentLanguage',
  CustomerRefId = 'customerRefId',
  CustomerUsername = 'customerUsername',
  SMARTWATCH_DATA = 'smartwatch_data',
  OpenModals = 'open_modals',
  SelfcareIdCheckSessionId = 'selfcareIdCheckSessionId',
  MfaEnabled = 'mfa_enabled',
  ScOfferTag = 'sc_offer_tag',
  ScOfferType = 'sc_offer_type',
}
